/**
 * @coeldery/form-select-field
 * 商戶管理 — 下拉欄位（含標籤、錯誤；可選空選項）
 *
 * 規格（.coappery/merchant_platform.md §2；rules.md §1）：
 *   - 與 form-text-field 同一套標籤／錯誤排版（視覺一致）
 *   - 顏色只用 CSS var；文字全部 via i18n t('key')
 *   - 純受控組件：options／value／onChange 全由 props 傳入，模組不內建任何選項資料
 *
 * 衍生自：src/ui.ts 既有樣式；原 MerchantForm.tsx 的 f-cat／f-tier 等 select 行為
 */
import { useTranslation } from 'react-i18next'
import { input, inputError, label, errText } from '../ui-kit'

export interface FormSelectOption {
  value: string
  label: string
}

export interface FormSelectFieldProps {
  /** 欄位 id（同時用於 label htmlFor 與自動測試選擇器）*/
  id: string
  /** 標籤 i18n key */
  labelKey: string
  /** 目前值（空字串＝未選）*/
  value: string
  onChange: (v: string) => void
  options: FormSelectOption[]
  /** 錯誤文字（已本地化；由驗證層產生）*/
  error?: string
}

export default function FormSelectField({ id, labelKey, value, onChange, options, error }: FormSelectFieldProps) {
  const { t } = useTranslation()
  return (
    <div>
      <label style={label} htmlFor={id}>{t(labelKey)}</label>
      <select
        id={id}
        style={error ? inputError : input}
        aria-invalid={error ? true : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      {error && <p style={errText}>{error}</p>}
    </div>
  )
}
